<!--<template>
  <div id="app">
    <router-view></router-view>
  </div>
</template>-->

<template>
  <v-app>
    <component v-bind:is="layout"></component>
  </v-app>
</template>

<style>
#srptCard .v-table thead th {
    white-space: normal!important;
}
</style>


<script>
import AdminLayout from "./layouts/AdminLayout";
import SimpleLayout from "./layouts/SimpleLayout";
import SaleLayout from "./layouts/SaleLayout";
import AccountantsLayout from "./layouts/AccountsLayout";
import { mapGetters } from "vuex";

export default {
  // name: 'adeton',

  computed: {
    ...mapGetters({
      layout: "Layouts/CURRENT_LAYOUT"
    })
  },
  components: {
    "admin-layout": AdminLayout,
    "accountants-layout": AccountantsLayout,
    "simple-layout": SimpleLayout,
    "sale-layout": SaleLayout
    // define as many layouts you want for the application
  },
 
};
</script>

<style>
/* CSS */
</style>